import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB-18531: Отключение кастомного loader-а на b2b для корректной работы Р7 2024.4.2.721 */
export const isDefaultR7LoaderForB2b = isFeature('is-default-r7-loader-for-b2b');
